import React from 'react';

// Types
import { Feature } from 'Shared/types/Organization.type';

// Hooks
import { useFeature } from 'Shared/utils/hooks';
import { useWorkspace } from 'Shared/utils/hooks/use-workspace';

// Components
import OneOnOneAndTeamSyncGoals from './WorkspaceGoals/OneOnOneAndTeamSyncGoals';
import GroupWorkspaceGoals from './WorkspaceGoals/GroupWorkspaceGoals';
import FreePlanGoalsContent from 'Shared/components/FreePlanGoalsContent/FreePlanGoalsContent';

const WorkspaceGoalsTab = () => {
  const { isFreePlan } = useFeature(Feature.goals);
  const { isGroup, isPersonal, id, isTeamSync } = useWorkspace();

  if (isFreePlan) return <FreePlanGoalsContent />;

  return (
    <div>
      {!isGroup || isTeamSync ? (
        <OneOnOneAndTeamSyncGoals isPersonal={isPersonal} workspaceId={id} />
      ) : (
        <GroupWorkspaceGoals workspaceId={id} />
      )}
    </div>
  );
};

export default WorkspaceGoalsTab;
